(function () {
  var mq = window.matchMedia('(pointer: fine) and (min-width: 990px)');
  var initialized = false;

  function initHoverMenu() {
    if (initialized) return;
    if (!mq.matches) return;
    initialized = true;

    document.body.classList.add('ryz-165');

    document.querySelectorAll('header-menu').forEach(function (headerMenu) {
      var details = headerMenu.querySelector('details');
      if (!details) return;
      var summary = details.querySelector('summary');

      summary.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
      });

      headerMenu.addEventListener('mouseenter', function () {
        details.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
      });

      headerMenu.addEventListener('mouseleave', function () {
        details.removeAttribute('open');
        summary.setAttribute('aria-expanded', 'false');
      });
    });
  }

  window.RYZ165 = { init: initHoverMenu };
})();
